<div class="tag" matTooltip="{{ tooltipText }}">
  <img *ngIf="!multipleTags" src="assets/images/arrows/tag-arrow.svg" />

  <div>{{ showTagText | ruleTagDisplayName }}</div>
</div>
